module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray-7724ca8380c500bc0790283fa85514cd.png";